// extracted by mini-css-extract-plugin
module.exports = {"Bug":"Bug_Bug__1_gox"};